module.exports = __webpack_public_path__ + "enr-static/img/no-data.7180548e.svg";